document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".joe-slider-largvideo_wrapper");

  // 创建视口观察器
  const carouselObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 当轮播图进入视口时，初始化该轮播图
          initCarousel(entry.target);
          // 初始化后取消观察此轮播图
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "200px", // 提前200px开始加载
      threshold: 0.1, // 当10%的元素可见时触发
    }
  );

  // 开始观察所有轮播图
  carousels.forEach((carousel) => {
    carouselObserver.observe(carousel);
  });

  function initCarousel(carousel) {
    const sectionId = carousel.getAttribute("data-section-id");
    const itemsContainer = carousel.querySelector(
      `.joe-slider-largvideo_items `
    );
    const items = carousel.querySelectorAll(`.joe-slider-largvideo_item`);

    // 计算滚动距离
    const cardNumber =
      parseInt(itemsContainer.getAttribute("data-slider-cards")) || 1;
    const cardElem = itemsContainer.querySelector(
      "div.joe-slider-largvideo_item"
    );
    if (!cardElem) return;

    const cardWidth = cardElem.offsetWidth;
    const gap =
      parseInt(window.getComputedStyle(itemsContainer).columnGap) || 0;
    const scrollDistance = (cardWidth + gap) * cardNumber;

    
    /*文件函数暂缓区*/

    function setupDragScroll() {
  const slider = itemsContainer;

  let isDown = false;
  let startX, scrollLeft, lastX;
  let momentumId;

  // 鼠标按下事件
  slider.addEventListener("pointerdown", (e) => {
    isDown = true;
    slider.style.cursor = "grabbing";
    slider.setPointerCapture(e.pointerId);
    startX = lastX = e.clientX;
    scrollLeft = slider.scrollLeft;
    cancelAnimationFrame(momentumId);
    
    // 立即停止任何平滑滚动效果
    slider.style.scrollBehavior = 'auto';
  });

  // 鼠标移动事件 - 优化响应速度
  slider.addEventListener(
    "pointermove",
    (e) => {
      if (!isDown) return;

      // 计算移动增量
      const x = e.clientX;
      // 增加系数到2.0，提高灵敏度
      const delta = (x - startX) * 1.1;
      
      // 直接设置滚动位置，不使用中间变量
      requestAnimationFrame(() => {
        slider.scrollLeft = scrollLeft - delta;
      });
      
      // 跟踪最后位置用于惯性计算
      lastX = x;

      // 防止其他事件干扰
      e.preventDefault();
      e.stopPropagation();
    },
    { passive: false }
  );

  // 鼠标释放事件处理
  function endDrag(e) {
    if (!isDown) return;

    // 计算最终速度 (基于最后移动)
    const velocity = (startX - lastX) * 0.2;
    
    slider.style.cursor = "grab";
    isDown = false;

    // 恢复平滑滚动效果用于惯性
    slider.style.scrollBehavior = 'smooth';
    
    // 应用惯性，使用更强的初始速度
    if (Math.abs(velocity) > 0.5) {
      applyMomentum(velocity);
    }
  }

  // 改进的惯性滚动
  function applyMomentum(initialVelocity) {
    let velocity = initialVelocity;
    
    function step() {
      // 增加每帧滚动量
      slider.scrollLeft += velocity;
      
      // 更慢的减速衰减
      velocity *= 0.95;
      
      if (Math.abs(velocity) > 0.2) {
        momentumId = requestAnimationFrame(step);
      } else {
        // 惯性结束后恢复默认滚动行为
        slider.style.scrollBehavior = 'smooth';
      }
    }
    
    momentumId = requestAnimationFrame(step);
  }

  // 绑定结束拖动事件
  slider.addEventListener("pointerup", endDrag);
  slider.addEventListener("pointercancel", endDrag);
  slider.addEventListener("pointerleave", endDrag);

  // 阻止拖拽干扰
  slider.addEventListener("dragstart", (e) => e.preventDefault());

  // 初始光标样式
  slider.style.cursor = "grab";

  // 优化链接点击行为 - 防止短暂快速拖动后意外点击
  slider.querySelectorAll("a, button").forEach((interactive) => {
    interactive.addEventListener("click", (e) => {
      if (Math.abs(startX - lastX) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
}

    /*文件函数暂缓区 end*/

    const isTouchDevice = window.matchMedia("(max-width: 990px)").matches;

    const videovideoItems = carousel.querySelectorAll("a.card-hover-display");

    if (isTouchDevice) {
      // 这里将添加触摸设备的视频控制代码
      setupTouchDeviceVideoControl();
    } else {
      // 保留原有的鼠标悬停逻辑
      setupDragScroll();
      setupDesktopHoverControl();
    }

    function setupDesktopHoverControl() {
      // const videovideoItems = carousel.querySelectorAll('a.card-hover-display');
      // 创建交叉观察器
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // 元素进入视口，初始化事件监听
              initVideoCard(entry.target);
              // 初始化后取消观察（不再需要观察此元素）
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null, // 相对于视口
          rootMargin: "10px", // 提前100px开始初始化
          threshold: 0.3, // 当10%的元素可见时触发
        }
      );

      // 开始观察所有视频卡片
      videovideoItems.forEach((item) => {
        observer.observe(item);
      });

      // 初始化单个视频卡片的函数
      function initVideoCard(item) {
        const video = item.querySelector(".joe-slider-largvideo_video");
        const coverImg = item.querySelector(".joe-slider-largvideo_item-cover");
        loadVideoSource(video);
        // 设置初始状态
        video.style.opacity = "0";
        coverImg.style.opacity = "1";

        // 添加所需的事件监听器
        video.addEventListener("ended", handleVideoEnd);
        item.addEventListener("mouseenter", handleMouseEnter);
        item.addEventListener("mouseleave", handleMouseLeave);

        // 事件处理函数
        function handleVideoEnd() {
          video.currentTime = 0;
          video.play();
          video.style.opacity = "0";
          coverImg.style.opacity = "1";
        }

        function handleMouseEnter() {
          video.style.opacity = "1";
          coverImg.style.opacity = "0";
          video.currentTime = 0;
          video.play();
        }

        function handleMouseLeave() {
          video.pause();
          if (!video.ended) {
            video.currentTime = 0;
            video.style.opacity = "0";
            coverImg.style.opacity = "1";
          }
        }

        function loadVideoSource(video) {
          const sources = video.querySelectorAll("source[data-src]");
          let loaded = false;

          sources.forEach((source) => {
            if (!source.src && source.dataset.src) {
              source.src = source.dataset.src;
              loaded = true;
            }
            if (source.src && source.dataset.src) {
              loaded = true;
            }
          });

          if (loaded) {
            // 通知浏览器重新加载视频资源
            video.load();
            return true;
          }

          return false;
        }
      }
    }

    function setupTouchDeviceVideoControl() {
      // 获取所有视频卡片
      const videoScrollContainer = carousel.querySelector(
        ".joe-slider-largvideo_items"
      );
      const videoItems = carousel.querySelectorAll(
        ".joe-slider-largvideo_item"
      );
      const navBarContainer = carousel.querySelector(
        ".joe-slider-largvideo_nav"
      );
      const navBar = navBarContainer.querySelector(
        ".joe-slider-largvideo_nav-bar"
      );

      const totalvideoItems = videoItems.length;
      const navWidth = navBarContainer.scrollWidth;
      const navBarWidth = `${navWidth / totalvideoItems}`;
      let isVideoScrolling;
      let currentVideoIndex = 0;
      let prevVideoIndex = 0;

      navBar.style.width = `${navBarWidth}px`;
      // 初始检测
      setTimeout(() => {
        currentVideoIndex = getcurrentVideoIndex();
        handleVideoChange(currentVideoIndex);
        handleNavChange(currentVideoIndex);
      }, 100);

      // 获取当前可见卡片索引的函数
      function getcurrentVideoIndex() {
        const containerRect = videoScrollContainer.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;

        let closestCard = null;
        let minDistance = Infinity;
        let closestIndex = 0;

        videoItems.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const distance = Math.abs(containerCenter - cardCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestCard = card;
            closestIndex = index;
          }
        });

        return closestIndex;
      }


    // 替换原有的滚动事件监听代码
      let lastScrollLeft = videoScrollContainer.scrollLeft;
      let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 滚动事件监听 - 只响应水平滚动
      videoScrollContainer.addEventListener(
        "scroll",
        function () {
          // 计算水平滚动距离
          const currentScrollLeft = videoScrollContainer.scrollLeft;
          const horizontalScrollDelta = Math.abs(currentScrollLeft - lastScrollLeft);
          
          // 获取页面垂直滚动距离
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const verticalScrollDelta = Math.abs(currentScrollTop - lastScrollTop);
          
          // 只有当水平滚动大于垂直滚动时才处理
          if (horizontalScrollDelta > verticalScrollDelta && horizontalScrollDelta > 5) {
            // 更新水平滚动位置
            lastScrollLeft = currentScrollLeft;
            
            // 清除之前的定时器
            window.clearTimeout(isVideoScrolling);
      
            // 设置新的定时器 - 在滚动停止150ms后触发
            isVideoScrolling = setTimeout(function () {
              // 滚动停止后的处理
              const newIndex = getcurrentVideoIndex();
      
              // 仅当索引改变时执行
              if (newIndex !== currentVideoIndex) {
                currentVideoIndex = newIndex;
      
                // 在这里执行你需要的操作，例如播放视频
                handleNavChange(currentVideoIndex);
                handleVideoChange(currentVideoIndex);
              }
            }, 150); // 减少延迟时间提高响应速度
          }
          
          // 无论如何都更新垂直滚动位置
          lastScrollTop = currentScrollTop;
        },
        { passive: true }
      );

      
      // 滚动事件监听
     /* videoScrollContainer.addEventListener(
        "scroll",
        function () {
          // 清除之前的定时器
          window.clearTimeout(isVideoScrolling);

          // 设置新的定时器 - 在滚动停止200ms后触发
          isVideoScrolling = setTimeout(function () {
            // 滚动停止后的处理
            const newIndex = getcurrentVideoIndex();

            // 仅当索引改变时执行
            if (newIndex !== currentVideoIndex) {
              currentVideoIndex = newIndex;

              // 在这里执行你需要的操作，例如播放视频
              handleNavChange(currentVideoIndex);
              handleVideoChange(currentVideoIndex);
            }
          }, 200);
        },
        { passive: true }
      );*/

      function loadVideoSource(video) {
        const sources = video.querySelectorAll("source[data-src]");
        let loaded = false;

        sources.forEach((source) => {
          if (!source.src && source.dataset.src) {
            source.src = source.dataset.src;
            loaded = true;
          }
          if (source.src && source.dataset.src) {
            loaded = true;
          }
        });

        if (loaded) {
          // 通知浏览器重新加载视频资源
          video.load();
          return true;
        }

        return false;
      }

      //处理底下同步nav的滚动变化
      function handleNavChange(index) {
        navBar.style.left = `${navBarWidth * index}px`;
      }

      // 处理卡片变化的函数(视频播放等操作)
      function handleVideoChange(index) {
        videoItems.forEach((card, i) => {
          const video = card.querySelector(".joe-slider-largvideo_video");
          const coverImg = card.querySelector(
            ".joe-slider-largvideo_item-cover"
          );

          if (!video || !coverImg) return;
          if (!video) return;

          video.addEventListener("ended", function () {
            video.currentTime = 0;
            video.play();
            video.style.opacity = "0";
            coverImg.style.opacity = "1";
          });

          if (i === index) {
            if (loadVideoSource(video)) {
              video.currentTime = 0;
              video.style.opacity = "1";
              coverImg.style.opacity = "0";
              video.play();
            }
          } else {
            // 暂停其他卡片视频
            video.pause();
            video.style.opacity = "0";
            coverImg.style.opacity = "1";
          }
        });
      }
    }
  }
});
